import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

interface DeleteProcessingActivityAssessmentListItemParams {
  processingActivityId: string
  assessmentId: string
}

export const deleteProcessingActivityAssessmentListItem = ({
  processingActivityId,
  assessmentId,
}: DeleteProcessingActivityAssessmentListItemParams) => {
  const entityUrl = `/api/risk-review/processing-activities/${processingActivityId}/assessments/${assessmentId}`
  return API.delete(
    formatRequestString({
      entityUrl,
    }),
  )
}
